import styled from 'styled-components'  
  
import InputMask from 'react-input-mask';
import MaterialInput from 'components/Input'

export const CentredContent = styled.div.attrs({ 
})`  
    padding-top: 215px;
    max-width: 325px;      
    margin: 0 auto;
    ${
        props => props.big ? `
            padding-top: 310px;
        ` : ``
    }
`;

export const FormContent = styled.div.attrs({ 
})`           
    max-width: 325px;
    margin: 0 auto;
    ${
        props => props.big ? `
            max-width: 425px;
        ` : ``
    } 
`;
 
export const FormTitle = styled.div.attrs({ 
})`           
    color: var(--primary-color); 
    font-weight: bold;
    font-size: 14px; 

    margin: 50px 0 10px;
    ${
        props => props.secondary ? `
            color: var(--secondary-color);
        ` : ``
    }
`;
export const FormText = styled.div.attrs({ 
    label: undefined
})`           
    color: var(--grey-color);
    font-size: 18px; 
    font-weight: bold;

    margin-bottom: 30px;
    ${
        props => props.white ? `
            color: var(--white-color);
        ` : ``
    }
    ${
        props => props.label ? `
            margin: 18px 0 12px;
        ` : ``
    }
`;




export const SelectedProfile = styled.div.attrs({ 
})`            
    display: flex;
    align-items: center;
    margin-top: 30px;
`;
export const SelectedProfileImage = styled.div.attrs({ 
})`            
    width: 80px;
    height: 80px;
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--lg-color);

    ${
        props => props.image ? `
            background: var(--lg-color) url(${ props.image }) no-repeat center center / cover ;
        ` : ``
    }

    margin-right: 20px;
`;
export const SelectedProfileImageIcon = styled.img.attrs({ 
    src: '/images/users/face.png',
    width: 53
})`            
`;
export const SelectedProfileTitle = styled.div.attrs({ 
})`            
    color: var(--black-color);
    font-size: 30px; 
    font-weight: bold;
`;
export const SelectProfileWrapper = styled.div.attrs({ 
})`            
    padding: 30px 0 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
`;
export const SelectProfileImage = styled.div.attrs({ 
})`           
    width: 80px;
    height: 80px;
    border-radius: 40px; 
    background: url(${ props => props.image }) no-repeat center center / cover ;

    cursor: pointer;
    &:hover{
        box-shadow: 0px 3px 6px var(--lightshadow-color);
    }

    ${
        props => props.active ? `
            border: 3px solid var(--primary-color);
        ` : ``
    }
`;

export const RowChoose = styled.div.attrs({ 
})`           
    display: flex;
    gap: 0 20px;
`;




export const DateInput = (props) => (
    <InputMask mask="99/99/9999" maskChar={null}  value={props.value} onChange={props.onChange}>
      {(inputProps) => <MaterialInput {...inputProps} outline type="tel" />}
    </InputMask>
);

export const CreateProfileContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  padding: 20px;
`;

export const ProfileForm = styled.form`
  background: rgb(41, 40, 40);
  padding: 30px;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
`;

export const FormInputGroup = styled.div`
  margin-bottom: 20px;
`;

export const FormLabel = styled.label`
  display: block;
  color: #fff;
  margin-bottom: 8px;
  font-size: 16px;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #555;
  background-color: #333;
  color: #fff;
  font-size: 16px;
  
  &:focus {
    outline: none;
    border-color: rgb(247, 144, 0);
  }
`;

export const AvatarUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 25px;
`;

export const AvatarPreview = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 60px;
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center;
  margin-bottom: 15px;
  border: 3px solid rgb(247, 144, 0);
`;

export const UploadButton = styled.button`
  background: rgb(63, 63, 63);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 15px;
  cursor: pointer;
  transition: background 0.3s;
  font-size: 14px;
  
  &:hover {
    background: rgb(80, 80, 80);
  }
`;

export const SubmitButton = styled.button`
  background: rgb(247, 144, 0);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px;
  width: 100%;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: background 0.3s;
  margin-top: 10px;
  
  &:hover {
    background: rgb(249, 178, 55);
  }
  
  &:disabled {
    background: #888;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  color: #ff6b6b;
  margin-bottom: 15px;
  text-align: center;
`;